<gipi-abstract-form id="dialogConnectConsult"
                    name="dialogConnectConsult"
                    [dialog]="true">
    <gipi-toolbar mat-dialog-title
                  id="toolbarDialogConnectConsult">
        Detalhamento da análise
    </gipi-toolbar>
    <div mat-dialog-content
         fxLayout="column"
         fxLayoutGap="16px"
         style="padding: 0 !important;">
        <iframe #reportIframe
                frameborder="0"
                width="100%"
                height="100%"
                style="flex: 1;"></iframe>
    </div>
    <div mat-dialog-actions
         fxLayout="row"
         fxLayoutAlign="end center"
         fxLayoutGap="16px">
        <gipi-button label="Voltar"
                     gipi-secondary
                     id="btnReturn"
                     name="btnReturn"
                     (click)="close('NONE')"
                     fxFlex="15"
                     fxFlex.lt-md="100">
        </gipi-button>
    </div>
</gipi-abstract-form>